// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Navbar_nav__343CN{\n    background-color: #000000;\n    color:white;\n}\n\n.Navbar_nav__343CN a{\n    text-decoration: none;\n    color:white;\n}", "",{"version":3,"sources":["webpack://src/components/Admin/Navbar/Navbar.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf","sourcesContent":[".nav{\n    background-color: #000000;\n    color:white;\n}\n\n.nav a{\n    text-decoration: none;\n    color:white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": "Navbar_nav__343CN"
};
export default ___CSS_LOADER_EXPORT___;
